/**
 * entries: [{ name: 'projects/', type: 'dir' | 'file' }]
 */
export default function LsOutput({ entries }) {
  return (
    <div className="flex flex-wrap gap-x-6 gap-y-1">
      {entries.map((e) => (
        <span key={e.name} className={e.type === "dir" ? "text-sky-400" : "text-neutral-300"}>
          {e.name}
        </span>
      ))}
    </div>
  );
}